var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 125.8438,
    viewBox: "0 0 125.8492 125.8438",
    width: 125.8492,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.000007.000549h125.8492v125.84325h-125.8492z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#27227d",
    transform: "translate(-193.0754 -193.0762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m199.37 318.92a6.29 6.29 0 0 1 -4.45-10.74l113.26-113.26a6.2932504 6.2932504 0 1 1 8.9 8.9l-113.26 113.26a6.29 6.29 0 0 1 -4.45 1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.63 318.92a6.29 6.29 0 0 1 -4.45-1.84l-113.26-113.26a6.2932504 6.2932504 0 0 1 8.9-8.9l113.26 113.26a6.29 6.29 0 0 1 -4.45 10.74z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b00af9608d8bcffe8234c81bd5151dbb.svg";
export { ForwardRef as ReactComponent };